module.exports = __webpack_public_path__ + "img/hr-red-asterisk-17.7ba644ab.png";